import { createSelector } from 'reselect';
import { detectPayment } from 'ggApp/utils/detectPayment';
import objectPath from 'object-path';

import { MODULE_NAME } from '../constants';

export const moduleState = (state) => state[MODULE_NAME];

export const fetching = createSelector(moduleState, (m) => m.fetching);

export const listStorePaymentMethods = createSelector(
    moduleState,
    (m) => m.listStorePaymentMethods,
);
export const activeStorePaymentMethodId = createSelector(
    moduleState,
    (m) => m.activeStorePaymentMethod,
);
export const storeCreditcard = createSelector(
    listStorePaymentMethods,
    (list) => list.find((pm) => pm.type === 'Spree::Gateway::BraintreeGateway') || {},
);

export const storePaypal = createSelector(
    listStorePaymentMethods,
    (list) => list.find((pm) => pm.type === 'Spree::Gateway::PayPalExpress') || {},
);

export const listUserPaymentMethods = createSelector(moduleState, (m) =>
    m.listUserPaymentMethods.map(detectPayment),
);
export const activeUserPaymentMethodId = createSelector(
    moduleState,
    (m) => m.activeUserPaymentMethod,
);
export const activeUserPaymentMethod = createSelector(
    listUserPaymentMethods,
    activeUserPaymentMethodId,
    (l, a) => {
        return l.find((p) => p.id === a);
    },
);
export const activePaymentMethodNavi = createSelector(
    activeUserPaymentMethod,
    (a) => (!!a && [`${a.name}`, `${a.description[0] || ''}`, `${a.description[1] || ''}`]) || [],
);

// Adyent oneclick payment
export const oneclick = createSelector(moduleState, (m) => m.oneclick);

export const oneclickLoading = createSelector(oneclick, (o) => o.loading);

export const oneclickPaymentData = createSelector(oneclick, (o) =>
    objectPath.get(o, 'data.payment_preview', {}),
);

export const oneclickRefusalReason = createSelector(oneclick, (o) =>
    objectPath.get(o, 'data.refusal_reason', ''),
);

export const oneclickPaymentCheckoutUrl = createSelector(oneclick, (o) =>
    objectPath.get(o, 'data.checkout_url', ''),
);

export const oneclickSubscriptions = createSelector(
    oneclickPaymentData,
    (opd) => opd.subscriptions || [],
);

export const oneclickErrorPaymentStatuses = createSelector(
    moduleState,
    (m) => m.oneclickErrorPaymentStatuses,
);

export const oneclickStatus = createSelector(moduleState, (m) => m.oneclickStatus);

export const oneclickNotificationStatus = createSelector(
    moduleState,
    (m) => m.oneclickNotificationStatus,
);

export const oneclickSessionData = createSelector(moduleState, (m) => m.oneclickSessionData);

export const oneclickSubmitDetails = createSelector(moduleState, (m) => m.oneclickSubmitDetails);

export const oneclickSubmitDetailsLoading = createSelector(oneclickSubmitDetails, (m) => m.loading);

export const flagr = createSelector(moduleState, (m) => m.oneclickAdyenDropInReplacement);

export const isAdyenDropInReplacementEnabled = createSelector(
    flagr,
    (m) => m.data && m.data.variantKey === 'enabled',
);

export const isFlagrLoading = createSelector(flagr, (m) => m.loading === true);
